export const emptyArray = <T = any>(): T[] => {
    return Object.freeze([] as any[]) as T[];
};
